import {useQueryClient, useMutation} from 'react-query'
import {QUERIES} from '../../../../../_metronic/helpers'
import {useListView} from '../../core/ListViewProvider'
import {useQueryResponse} from '../../core/QueryResponseProvider'
import {deleteSelectedClassifiedPosts, restoreSelectedClassifiedPosts} from '../../core/_requests'
import {toast} from 'react-toastify'

const ListGrouping = () => {
  const {selected, clearSelected} = useListView()
  const queryClient = useQueryClient()
  const {query} = useQueryResponse()

  const deleteSelectedItems = useMutation(() => deleteSelectedClassifiedPosts(selected), {
    onSuccess: () => {
      queryClient.invalidateQueries([`${QUERIES.CLASSIFIED_POSTS_LIST}-${query}`])
      clearSelected()
      toast.success('Selected posts deleted successfully')
    },
    onError: () => {
      toast.error('Failed to delete selected posts')
    },
  })

  const restoreSelectedItems = useMutation(() => restoreSelectedClassifiedPosts(selected), {
    onSuccess: () => {
      queryClient.invalidateQueries([`${QUERIES.CLASSIFIED_POSTS_LIST}-${query}`])
      clearSelected()
      toast.success('Selected posts restored successfully')
    },
    onError: () => {
      toast.error('Failed to restore selected posts')
    },
  })

  return (
    <div className='d-flex justify-content-end align-items-center'>
      <div className='fw-bolder me-5'>
        <span className='me-2'>{selected.length}</span> Selected
      </div>

      <div className='d-flex gap-2'>
        <button
          type='button'
          className='btn btn-light-primary'
          onClick={async () => await restoreSelectedItems.mutateAsync()}
          disabled={restoreSelectedItems.isLoading || deleteSelectedItems.isLoading}
        >
          Restore Selected
        </button>
        <button
          type='button'
          className='btn btn-danger'
          onClick={async () => await deleteSelectedItems.mutateAsync()}
          disabled={deleteSelectedItems.isLoading || restoreSelectedItems.isLoading}
        >
          Delete Selected
        </button>
      </div>
    </div>
  )
}

export {ListGrouping}
